// extracted by mini-css-extract-plugin
module.exports = {"root":"StatusTableFilter_root__2bQPH","text":"StatusTableFilter_text__2rl61","rightCol":"StatusTableFilter_rightCol__1rMrZ"};